import { render, staticRenderFns } from "./OchartCharacter.vue?vue&type=template&id=2d739cde&scoped=true&"
import script from "./OchartCharacter.vue?vue&type=script&lang=js&"
export * from "./OchartCharacter.vue?vue&type=script&lang=js&"
import style0 from "./OchartCharacter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OchartCharacter.vue?vue&type=style&index=1&id=2d739cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d739cde",
  null
  
)

export default component.exports